import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

import type {
  CategoryData,
  CategoryDef,
  CategoriesDataParams,
} from '../types';

export class ScorecardsClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor({
    discoveryApi,
    fetchApi,
  }: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  async getCategories(): Promise<CategoryDef[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('watchtower-api');
    const response = await this.fetchApi.fetch(`${baseUrl}/categories`);
    if (!response.ok) {
      throw new Error(`Failed to fetch categories: ${response.statusText}`);
    }
    return response.json();
  }

  async getCategoriesData(params: CategoriesDataParams): Promise<CategoryData[]> {
    const { teamIds, startDate, endDate, aggregateBy = 'month' } = params;
    const baseUrl = await this.discoveryApi.getBaseUrl('watchtower-api');
    const response = await this.fetchApi.fetch(`${baseUrl}/categories-data`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        team_ids: teamIds,
        start_date: startDate,
        end_date: endDate,
        aggregate_by: aggregateBy,
      }),
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch categories data: ${response.statusText}`);
    }
    return response.json();
  }
}